import React from "react";
import ConnectedNewPaymentMethods from "./ConnectedNewPaymentMethods";
import ConnectedOnePayPaymentMethods from "./ConnectedOnePayPaymentMethods";
import ConnectedTogglePaymentMethodsButton from "./ConnectedTogglePaymentMethodsButton";
import ConnectedStoredPaymentMethods from "./ConnectedStoredPaymentMethods";

/**
 * @param {object} props
 * @param {number} props.controlId
 * @param {boolean} props.displayOnePayPaymentMethods
 * @param {boolean} props.displayOriginalNewPaymentMethods
 * @param {boolean} props.displayStoredPaymentMethods
 * @param {boolean} props.hasToggledPaymentMethodView
 * @param {Function} props.handleTogglePaymentMethodsButtonClick
 * @returns {React.ReactElement}
 */
const PaymentMethods = ({
    controlId,
    displayOnePayPaymentMethods,
    displayOriginalNewPaymentMethods,
    displayStoredPaymentMethods,
    hasToggledPaymentMethodView,
    handleTogglePaymentMethodsButtonClick,
}) => (
    <>
        {/* Do not need to be wrapped in col classes as each component has a col class within it */}
        {displayStoredPaymentMethods && (
            <ConnectedStoredPaymentMethods
                controlId={controlId}
                hasToggledPaymentMethodView={hasToggledPaymentMethodView}
            />
        )}
        {displayOnePayPaymentMethods && <ConnectedOnePayPaymentMethods />}
        {displayOriginalNewPaymentMethods && (
            <ConnectedNewPaymentMethods
                controlId={controlId}
                hasToggledPaymentMethodView={hasToggledPaymentMethodView}
            />
        )}
        <ConnectedTogglePaymentMethodsButton
            controlId={controlId}
            displayStoredPaymentMethods={displayStoredPaymentMethods}
            handleTogglePaymentMethodsButtonClick={
                handleTogglePaymentMethodsButtonClick
            }
        />
    </>
);

export default PaymentMethods;
